import { pluralize } from '@/utils/format';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Box, IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { BulkDeleteReportsModal } from './BulkDeleteReportsModal';

const Sidebar = styled(Box, {
  shouldForwardProp: property => property !== 'isOpen',
})<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  display: isOpen ? 'flex' : 'none',
  width: 60,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  flexShrink: 0,
}));

const ActionButton = styled(IconButton)({
  width: 40,
  height: 40,
});

export const BulkDeleteSidebar = ({
  selectedReportIds,
  onDelete,
}: {
  selectedReportIds: string[];
  onDelete: () => void;
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteModalOpen = () => {
    setDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
  };

  const handleDeleteComplete = () => {
    onDelete();
    handleDeleteModalClose();
  };

  const selectedCount = selectedReportIds.length;
  const shouldShowSidebar = selectedCount > 0;

  return (
    <>
      <Sidebar isOpen={shouldShowSidebar}>
        <Tooltip title={`Delete ${pluralize(selectedCount, 'selected report', 'selected reports')}`}>
          <span>
            <ActionButton color='error' onClick={handleDeleteModalOpen}>
              <DeleteIcon />
            </ActionButton>
          </span>
        </Tooltip>
      </Sidebar>
      <BulkDeleteReportsModal
        open={deleteModalOpen}
        onClose={handleDeleteModalClose}
        selectedReportIds={selectedReportIds}
        onDeleteComplete={handleDeleteComplete}
      />
    </>
  );
};
